import LogoSvg from "../Logo"

const PageLoading = () => {
  return (
    <div className="fixed inset-0 z-9999 flex flex-col items-center justify-center gap-10 bg-white">
      <style>{`
        @keyframes logoDraw {
          0%   { stroke-dashoffset: 1; fill-opacity: 0; }
          60%  { stroke-dashoffset: 0; fill-opacity: 0; }
          100% { stroke-dashoffset: 0; fill-opacity: 1; }
        }
        @keyframes dotPulse {
          0%, 100% { opacity: 0.25; transform: scale(0.75); }
          50%       { opacity: 1;    transform: scale(1);    }
        }
        .lp-green {
          fill: #089208;
          fill-opacity: 0;
          stroke: #089208;
          stroke-width: 1;
          stroke-dasharray: 1;
          stroke-dashoffset: 1;
          animation: logoDraw 1s cubic-bezier(0.4, 0, 0.2, 1) 0s both;
        }
        .lp-black {
          fill: #000000;
          fill-opacity: 0;
          stroke: #000000;
          stroke-width: 0.3;
          stroke-dasharray: 1;
          stroke-dashoffset: 1;
          animation: logoDraw 1s cubic-bezier(0.4, 0, 0.2, 1) 0.75s both;
        }
      `}</style>
      <LogoSvg className="w-60 animate-pulse" />

      {/* bouncing dots */}
      <div className="flex items-center gap-2">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              display: 'block',
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: '#089208',
              animation: `dotPulse 1.2s ease-in-out ${i * 0.2}s infinite`,
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default PageLoading
